import { forwardRef, type TextareaHTMLAttributes } from "react";
import { cn } from "@/components/ui/cn";

type VTextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  invalid?: boolean;
};

export const VTextarea = forwardRef<HTMLTextAreaElement, VTextareaProps>(
  ({ className, invalid, ...props }, ref) => (
    <textarea
      ref={ref}
      className={cn(
        "flex min-h-[80px] w-full rounded-lg border bg-card px-3 py-2 text-sm shadow-xs transition-colors",
        "placeholder:text-muted-foreground",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1",
        "disabled:cursor-not-allowed disabled:opacity-50",
        invalid ? "border-error-500" : "border-input",
        className,
      )}
      {...props}
    />
  ),
);
VTextarea.displayName = "VTextarea";

export type { VTextareaProps };
